export enum PurchasePlatform {
  ios = 'ios',
  android = 'android',
  boomstarter = 'boomstarter',
}
